import { useState, useEffect, useRef } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const SearchInput = ({ onSearch, placeholder = "Search..." }) => {
  const [searchTerm, setSearchTerm] = useState("");
  // Callers often pass an inline handler (new identity every render). Keep it in a
  // ref so the debounce depends only on the typed term — depending on `onSearch`
  // caused a fetch → re-render → new handler → fetch loop (~1 req/sec).
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  // Last term emitted; starts "" so mount doesn't fire (pages load their own data).
  const lastSentRef = useRef("");

  useEffect(() => {
    // Debounce search input
    const timer = setTimeout(() => {
      if (searchTerm === lastSentRef.current) return;
      lastSentRef.current = searchTerm;
      onSearchRef.current(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  return (
    <div className="relative w-full max-w-sm">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
      <Input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10"
      />
    </div>
  );
};

export default SearchInput;
